import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// English
import enCommon from './i18n/en/common.json';
import enHome from './i18n/en/home.json';
import enAuth from './i18n/en/auth.json';
import enDashboard from './i18n/en/dashboard.json';
import enTender from './i18n/en/tender.json';
import enExchange from './i18n/en/exchange.json';
import enCompanies from './i18n/en/companies.json';
import enSettings from './i18n/en/settings.json';
import enTeam from './i18n/en/team.json';
import enNotifications from './i18n/en/notifications.json';
import enAdmin from './i18n/en/admin.json';
import enCountries from './i18n/en/countries.json';
import enFleet from './i18n/en/fleet.json';
import enBids from './i18n/en/bids.json';
import enDrivers from './i18n/en/drivers.json';
import enTrack from './i18n/en/track.json';
import enFleetVehicles from './i18n/en/fleetVehicles.json';
import enFleetMap from './i18n/en/fleetMap.json';
import enAssign from './i18n/en/assign.json';
import enOrders from './i18n/en/orders.json';
import enReports from './i18n/en/reports.json';
import enAssistant from './i18n/en/assistant.json';

// Slovak
import skCommon from './i18n/sk/common.json';
import skHome from './i18n/sk/home.json';
import skAuth from './i18n/sk/auth.json';
import skDashboard from './i18n/sk/dashboard.json';
import skTender from './i18n/sk/tender.json';
import skExchange from './i18n/sk/exchange.json';
import skCompanies from './i18n/sk/companies.json';
import skSettings from './i18n/sk/settings.json';
import skTeam from './i18n/sk/team.json';
import skNotifications from './i18n/sk/notifications.json';
import skAdmin from './i18n/sk/admin.json';
import skCountries from './i18n/sk/countries.json';
import skFleet from './i18n/sk/fleet.json';
import skBids from './i18n/sk/bids.json';
import skDrivers from './i18n/sk/drivers.json';
import skTrack from './i18n/sk/track.json';
import skFleetVehicles from './i18n/sk/fleetVehicles.json';
import skFleetMap from './i18n/sk/fleetMap.json';
import skAssign from './i18n/sk/assign.json';
import skOrders from './i18n/sk/orders.json';
import skReports from './i18n/sk/reports.json';
import skAssistant from './i18n/sk/assistant.json';

// Czech
import csCommon from './i18n/cs/common.json';
import csHome from './i18n/cs/home.json';
import csAuth from './i18n/cs/auth.json';
import csDashboard from './i18n/cs/dashboard.json';
import csTender from './i18n/cs/tender.json';
import csExchange from './i18n/cs/exchange.json';
import csCompanies from './i18n/cs/companies.json';
import csSettings from './i18n/cs/settings.json';
import csTeam from './i18n/cs/team.json';
import csNotifications from './i18n/cs/notifications.json';
import csAdmin from './i18n/cs/admin.json';
import csCountries from './i18n/cs/countries.json';
import csFleet from './i18n/cs/fleet.json';
import csBids from './i18n/cs/bids.json';
import csDrivers from './i18n/cs/drivers.json';
import csTrack from './i18n/cs/track.json';
import csFleetVehicles from './i18n/cs/fleetVehicles.json';
import csFleetMap from './i18n/cs/fleetMap.json';
import csAssign from './i18n/cs/assign.json';
import csOrders from './i18n/cs/orders.json';
import csReports from './i18n/cs/reports.json';
import csAssistant from './i18n/cs/assistant.json';

// Polish
import plCommon from './i18n/pl/common.json';
import plHome from './i18n/pl/home.json';
import plAuth from './i18n/pl/auth.json';
import plDashboard from './i18n/pl/dashboard.json';
import plTender from './i18n/pl/tender.json';
import plExchange from './i18n/pl/exchange.json';
import plCompanies from './i18n/pl/companies.json';
import plSettings from './i18n/pl/settings.json';
import plTeam from './i18n/pl/team.json';
import plNotifications from './i18n/pl/notifications.json';
import plAdmin from './i18n/pl/admin.json';
import plCountries from './i18n/pl/countries.json';
import plFleet from './i18n/pl/fleet.json';
import plBids from './i18n/pl/bids.json';
import plDrivers from './i18n/pl/drivers.json';
import plTrack from './i18n/pl/track.json';
import plFleetVehicles from './i18n/pl/fleetVehicles.json';
import plFleetMap from './i18n/pl/fleetMap.json';
import plAssign from './i18n/pl/assign.json';
import plOrders from './i18n/pl/orders.json';
import plReports from './i18n/pl/reports.json';
import plAssistant from './i18n/pl/assistant.json';

// German
import deCommon from './i18n/de/common.json';
import deHome from './i18n/de/home.json';
import deAuth from './i18n/de/auth.json';
import deDashboard from './i18n/de/dashboard.json';
import deTender from './i18n/de/tender.json';
import deExchange from './i18n/de/exchange.json';
import deCompanies from './i18n/de/companies.json';
import deSettings from './i18n/de/settings.json';
import deTeam from './i18n/de/team.json';
import deNotifications from './i18n/de/notifications.json';
import deAdmin from './i18n/de/admin.json';
import deCountries from './i18n/de/countries.json';
import deFleet from './i18n/de/fleet.json';
import deBids from './i18n/de/bids.json';
import deDrivers from './i18n/de/drivers.json';
import deTrack from './i18n/de/track.json';
import deFleetVehicles from './i18n/de/fleetVehicles.json';
import deFleetMap from './i18n/de/fleetMap.json';
import deAssign from './i18n/de/assign.json';
import deOrders from './i18n/de/orders.json';
import deReports from './i18n/de/reports.json';
import deAssistant from './i18n/de/assistant.json';

// Romanian
import roCommon from './i18n/ro/common.json';
import roHome from './i18n/ro/home.json';
import roAuth from './i18n/ro/auth.json';
import roDashboard from './i18n/ro/dashboard.json';
import roTender from './i18n/ro/tender.json';
import roExchange from './i18n/ro/exchange.json';
import roCompanies from './i18n/ro/companies.json';
import roSettings from './i18n/ro/settings.json';
import roTeam from './i18n/ro/team.json';
import roNotifications from './i18n/ro/notifications.json';
import roAdmin from './i18n/ro/admin.json';
import roCountries from './i18n/ro/countries.json';
import roFleet from './i18n/ro/fleet.json';
import roBids from './i18n/ro/bids.json';
import roDrivers from './i18n/ro/drivers.json';
import roTrack from './i18n/ro/track.json';
import roFleetVehicles from './i18n/ro/fleetVehicles.json';
import roFleetMap from './i18n/ro/fleetMap.json';
import roAssign from './i18n/ro/assign.json';
import roOrders from './i18n/ro/orders.json';
import roReports from './i18n/ro/reports.json';
import roAssistant from './i18n/ro/assistant.json';

// Hungarian
import huCommon from './i18n/hu/common.json';
import huHome from './i18n/hu/home.json';
import huAuth from './i18n/hu/auth.json';
import huDashboard from './i18n/hu/dashboard.json';
import huTender from './i18n/hu/tender.json';
import huExchange from './i18n/hu/exchange.json';
import huCompanies from './i18n/hu/companies.json';
import huSettings from './i18n/hu/settings.json';
import huTeam from './i18n/hu/team.json';
import huNotifications from './i18n/hu/notifications.json';
import huAdmin from './i18n/hu/admin.json';
import huCountries from './i18n/hu/countries.json';
import huFleet from './i18n/hu/fleet.json';
import huBids from './i18n/hu/bids.json';
import huDrivers from './i18n/hu/drivers.json';
import huTrack from './i18n/hu/track.json';
import huFleetVehicles from './i18n/hu/fleetVehicles.json';
import huFleetMap from './i18n/hu/fleetMap.json';
import huAssign from './i18n/hu/assign.json';
import huOrders from './i18n/hu/orders.json';
import huReports from './i18n/hu/reports.json';
import huAssistant from './i18n/hu/assistant.json';

// Detect language from URL or localStorage
const getInitialLanguage = (): string => {
  const savedLang = localStorage.getItem('i18nextLng');
  const supportedLangs = ['en', 'sk', 'pl', 'de', 'cs', 'hu', 'ro'];
  if (savedLang && supportedLangs.includes(savedLang)) {
    return savedLang;
  }
  return 'sk';
};

// Merge all section files into a single translation object per language
const merge = (...parts: object[]) => Object.assign({}, ...parts);

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: merge(enCommon, enHome, enAuth, enDashboard, enTender, enExchange, enCompanies, enSettings, enTeam, enNotifications, enAdmin, enCountries, enFleet, enBids, enDrivers, enTrack, enFleetVehicles, enFleetMap, enAssign, enOrders, enReports, enAssistant) },
      sk: { translation: merge(skCommon, skHome, skAuth, skDashboard, skTender, skExchange, skCompanies, skSettings, skTeam, skNotifications, skAdmin, skCountries, skFleet, skBids, skDrivers, skTrack, skFleetVehicles, skFleetMap, skAssign, skOrders, skReports, skAssistant) },
      cs: { translation: merge(csCommon, csHome, csAuth, csDashboard, csTender, csExchange, csCompanies, csSettings, csTeam, csNotifications, csAdmin, csCountries, csFleet, csBids, csDrivers, csTrack, csFleetVehicles, csFleetMap, csAssign, csOrders, csReports, csAssistant) },
      pl: { translation: merge(plCommon, plHome, plAuth, plDashboard, plTender, plExchange, plCompanies, plSettings, plTeam, plNotifications, plAdmin, plCountries, plFleet, plBids, plDrivers, plTrack, plFleetVehicles, plFleetMap, plAssign, plOrders, plReports, plAssistant) },
      de: { translation: merge(deCommon, deHome, deAuth, deDashboard, deTender, deExchange, deCompanies, deSettings, deTeam, deNotifications, deAdmin, deCountries, deFleet, deBids, deDrivers, deTrack, deFleetVehicles, deFleetMap, deAssign, deOrders, deReports, deAssistant) },
      hu: { translation: merge(huCommon, huHome, huAuth, huDashboard, huTender, huExchange, huCompanies, huSettings, huTeam, huNotifications, huAdmin, huCountries, huFleet, huBids, huDrivers, huTrack, huFleetVehicles, huFleetMap, huAssign, huOrders, huReports, huAssistant) },
      ro: { translation: merge(roCommon, roHome, roAuth, roDashboard, roTender, roExchange, roCompanies, roSettings, roTeam, roNotifications, roAdmin, roCountries, roFleet, roBids, roDrivers, roTrack, roFleetVehicles, roFleetMap, roAssign, roOrders, roReports, roAssistant) },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'sk',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
